module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-38.85d39a58.png";